import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../styles/Pages.css';
import { handleLinkClick } from '../utils/deviceUtils';
import images from '../assets/index';

function Services() {

  useEffect(() => {
    document.title = "Services | Datamatics Consulting";
  }, []);
  const expertiseAreas = [
    {
      title: "Enterprise Data & AI Services",
      image: images.comp,
      description: "Empower Decisions. Govern Data. Scale Intelligence.",
      link: "/services/enterprise-data-ai-services",
      isContact: false
    },
    {
      title: "Technology & Cloud Services",
      image: images.globe,
      description: "Cloud-Native, Future-Proof, and Ready to Scale.",
      link: "/services/technology-cloud-services",
      isContact: false
    },
    {
      title: "Advanced Analytics & AI Enablement",
      image: images.robot,
      description: "From Dashboards to Decisions—Powering Real-Time Intelligence.",
      link: "/services/advanced-analytics-ai-enablement",
      isContact: false
    },
    {
      title: "Cloud Acceleration Studio",
      image: images.cloud2,
      description: "Your Fast Track to Agile, Scalable, and AI-Optimized Cloud.",
      link: "/services/cloud-acceleration-studio",
      isContact: false
    },
    {
      title: "Cybersecurity and Digital Trust",
      image: images.cyber2,
      description: "Secure by Design. Trusted by Default. Resilient by Architecture.",
      link: "/services/cybersecurity-and-digital-trust",
      isContact: false
    },
    {
      title: "Custom Solution Development",
      image: images.customsol,
      description: "Custom Solution Development Tailored To Your Vision. Built for Performance. Scaled for Tomorrow.",
      link: "/contact",
      isContact: true
    }
  ];

  return (
    <Container className="page-container">
      {/* Areas of Expertise */}
      <section className="expertise-section">
        <div>
          <h2 className="section-title-main">Our Core Areas</h2>
          <div className="expertise-grid">
            {expertiseAreas.map((area, index) => (
              <div key={index} className="expertise-card">
                <img src={area.image} alt={area.title} className="card-image" />
                <div className="card-content">
                  <h3 className="card-title">{area.title}</h3>
                </div>
                <div className="card-hover-overlay">
                  <p className="card-description">{area.description}</p>
                  {area.isContact ? (
                    <Link
                      to="/contact"
                      className="card-btn contact-btn"
                      onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}
                    >
                      Contact Us
                    </Link>
                  ) : (
                    <a
                      href={area.link}
                      className="card-btn"
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick(area.link);
                      }}
                    >
                      Learn More
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Container>
  );
}

export default Services;